import adminHttp from "@/api/adminHttp";

export default {
    getStatistic: (fromDate, toDate) =>  adminHttp.get('/api/v1/admin/telegram-mailing/stat', {
        params: {
            from: fromDate,
            to: toDate
        }
    })
}